import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Quiz3OpenExamBanner from "./Quiz3OpenExamBanner";

// GEN-01 — Trang chủ Quiz3 (bản cơ bản, công khai). Không có trường/lớp/
// giáo viên/Admin ở chương trình này — mọi tài khoản đã đăng nhập đều có
// đủ 2 năng lực: Làm bài và Soạn câu hỏi.
const menuItems = [
  {
    to: "/quiz3/take",
    label: "Làm bài",
    description:
      "Chọn môn học, chủ đề và đề thi (đề cố định hoặc đề tổng hợp random) để luyện thi. Xem điểm và đáp án ngay sau khi nộp bài.",
    icon: "📝",
  },
  {
    to: "/quiz3/history",
    label: "Lịch sử làm bài",
    description: "Xem lại các lượt làm bài đã qua, điểm số theo thời gian, lọc theo môn/chủ đề.",
    icon: "📊",
  },
  {
    to: "/quiz3/author",
    label: "Soạn câu hỏi",
    description:
      "Quản lý cây môn học/chủ đề, ngân hàng câu hỏi công khai, và tạo đề cố định/đề tổng hợp. Ai cũng soạn được; chỉ người tạo mới sửa/xóa được nội dung của mình.",
    icon: "✍️",
  },
  {
    to: "/quiz3/scan-batch",
    label: "Chấm cả phòng (phiếu THPT 3 phần)",
    description:
      "Tải file PDF scan phiếu trả lời của cả phòng thi: máy đọc SBD, mã đề, Phần I/II/III từng phiếu, chấm điểm theo file đáp án Excel, đánh dấu phiếu cần xem lại và xuất Excel.",
    icon: "🖨️",
  },
];

const Quiz3Home = () => {
  const [authChecked, setAuthChecked] = useState(false);

  // Đăng nhập không còn qua Firebase Auth — chỉ cần đánh dấu đã kiểm tra
  // xong ngay lập tức (đồng bộ), không cần lắng nghe sự kiện nữa.
  useEffect(() => {
    setAuthChecked(true);
  }, []);

  return (
    <div style={containerStyle}>
      <style>{`
        .quiz3-menu-card {
          display: flex;
          align-items: center;
          gap: 16px;
          padding: 16px;
          border: 1px solid #e5e7eb;
          border-radius: 12px;
          background: #ffffff;
          text-decoration: none;
          color: inherit;
          transition: all 0.2s ease-in-out;
          box-shadow: 0 1px 3px rgba(0,0,0,0.05);
        }
        .quiz3-menu-card:hover {
          transform: translateY(-2px);
          box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.05), 0 4px 6px -2px rgba(0, 0, 0, 0.05);
          border-color: #3b82f6;
          background: #f8fafc;
        }
        .quiz3-menu-icon-container {
          width: 60px;
          height: 60px;
          border-radius: 12px;
          display: flex;
          align-items: center;
          justify-content: center;
          background: #f3f4f6;
          font-size: 28px;
          flex-shrink: 0;
          transition: transform 0.2s ease-in-out;
        }
        .quiz3-menu-card:hover .quiz3-menu-icon-container {
          transform: scale(1.05);
        }
        .quiz3-menu-content {
          display: flex;
          flex-direction: column;
          text-align: left;
        }
        .quiz3-menu-title {
          margin: 0 0 4px 0;
          font-size: 16px;
          font-weight: 600;
          color: #1f2937;
          transition: color 0.2s ease-in-out;
        }
        .quiz3-menu-card:hover .quiz3-menu-title {
          color: #2563eb;
        }
        .quiz3-menu-desc {
          margin: 0;
          font-size: 13px;
          color: #4b5563;
          line-height: 1.5;
          text-align: justify;
          text-align-last: left;
        }
        @media (max-width: 640px) {
          .quiz3-menu-card {
            flex-direction: column;
            align-items: flex-start;
            gap: 12px;
          }
        }
      `}</style>

      <h2 style={titleStyle}>Quiz3</h2>
      <div style={subtitleStyle}>
        <p style={{ margin: "0 0 12px 0" }}>
          Luyện thi trắc nghiệm trực tuyến, hoàn toàn công khai: ai đã đăng nhập cũng làm bài được, cũng soạn câu
          hỏi được — không có trường/lớp/giáo viên ở chương trình này.
        </p>
      </div>

      {!authChecked ? (
        <p style={{ color: "#6b7280" }}>Đang tải...</p>
      ) : (
        <>
          <Quiz3OpenExamBanner />
          <div style={gridStyle}>
          {menuItems.map((item) => (
            <Link key={item.to} to={item.to} className="quiz3-menu-card">
              <div className="quiz3-menu-icon-container">{item.icon}</div>
              <div className="quiz3-menu-content">
                <h3 className="quiz3-menu-title">{item.label}</h3>
                <p className="quiz3-menu-desc">{item.description}</p>
              </div>
            </Link>
          ))}
          </div>
        </>
      )}
    </div>
  );
};

const containerStyle = {
  padding: 24,
  width: "100%",
  boxSizing: "border-box",
  maxWidth: 1200,
  margin: "0 auto",
};

const titleStyle = {
  margin: "0 0 8px 0",
  fontSize: 24,
  fontWeight: 700,
  color: "#111827",
};

const subtitleStyle = {
  margin: "0 0 24px 0",
  color: "#333333",
  fontSize: 16,
};

const gridStyle = {
  display: "grid",
  gridTemplateColumns: "repeat(auto-fill, minmax(320px, 1fr))",
  gap: 16,
};

export default Quiz3Home;
